import { useContext } from "react";
import { ModalContext } from "./ModalContext";

export const useModal = () => {
  const { onClose, closeLabel, titleId, setTitleId } = useContext(ModalContext);

  return { onClose, closeLabel, titleId, setTitleId };
};
